import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Page from '../../components/page/Page';
import WhiteContainer from '../../components/containers/WhiteContainer';
import text from '../../text';
import Button from '../../components/button/Button';
import routes from '../../routes/constants';
import { alertConstants } from '../../redux/constants/alert';
var AssignedPaymentStatus = function() {
    var history = useHistory();
    var dispatch = useDispatch();
    var currentUser = useSelector(function(state) {
        return {
            currentUser: state.profileReducer.userProfile
        };
    }).currentUser;
    var payerEmail = history.location.state.payerEmail;
    var payerName = history.location.state.payerName;
    var isMembership = history.location.state.isMembership;
    useEffect(function() {
        if (payerEmail && payerName) {
            dispatch({
                type: alertConstants.ALERT_INFO,
                payload: {
                    message: text(isMembership ? 'requestSentSuccessfully' : 'quoteSentSuccessfully'),
                    icon: 'envelope-with-tick',
                    dismissible: true
                }
            });
        }
    }, []);
    return /*#__PURE__*/ React.createElement(Page, {
        className: "PaymentStatus PageCenter"
    }, /*#__PURE__*/ React.createElement(WhiteContainer, {
        className: "p-5 "
    }, /*#__PURE__*/ React.createElement(WhiteContainer.Header, {
        title: text(isMembership ? 'requestEmailed' : 'quoteEmailed')
    }), /*#__PURE__*/ React.createElement("div", {
        className: "text-center mb-5"
    }, /*#__PURE__*/ React.createElement("div", null, text(isMembership ? 'payerHasBeenSentRequest' : 'payerHasBeenSentQuote', {
        payerName: payerName,
        payerEmail: /*#__PURE__*/ React.createElement("p", {
            className: "font-weight-bold m-0"
        }, payerEmail)
    })), /*#__PURE__*/ React.createElement("div", null, text('whenPaidNotified', {
        userEmail: /*#__PURE__*/ React.createElement("p", {
            className: "font-weight-bold m-0"
        }, currentUser.email)
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "d-flex justify-content-center"
    }, /*#__PURE__*/ React.createElement(Button, {
        onClick: function() {
            return history.push(routes.dashboard);
        }
    }, text('goToDashboard')))));
};
export default AssignedPaymentStatus;
